export default __webpack_public_path__ + "static/media/pass.a450f231.png";